export default __webpack_public_path__ + "static/media/arrow_back.8864dc73.svg";